import { call, put, select, takeLatest } from "redux-saga/effects"
import {
	CREATE_REVIEW_REQUEST,
	GET_ALL_REVIEWS_LIST_REQUEST,
	GET_REVIEW_BASED_ON_ID,
	GET_REVIEW_LIST_REQUEST,
	GET_REVIEW_REQUEST,
	UPDATE_REVIEW_STATUS,
} from "../types"
import { reviewService } from "../services/review.services"
import {
	createReviewRequestFailed,
	createReviewRequestSuccess,
	getAllReviewListFailed,
	getAllReviewListSuccess,
	getReviewBasedOnFileIdFailed,
	getReviewBasedOnFileIdSuccess,
	getReviewListFailed,
	getReviewListSuccess,
	getReviewRequestFailed,
	getReviewRequestSuccess,
	setReviewAsignee,
	setReviewAssigneeMap,
	setReviewRestrictIds,
	updateReviewStatusFailed,
	updateReviewStatusSuccess,
} from "../actions/reviewActions"
import { setNotification } from "../actions/notificationActions"
import { updateReviewAsignee, updateReviewAsigneeMap } from "../utils"
import { updateDocumentModalReview } from "../actions/documentModalActions"

function* createReviewSaga(action) {
	try {
		const { id, ...data } = action?.payload
		const result = yield call(reviewService.createUpdateReview, data, id)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(createReviewRequestSuccess(result?.data))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(createReviewRequestFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(createReviewRequestFailed(error))
		yield put(
			setNotification({
				data: error,
				severity: "error",
			})
		)
	}
}

function* getReviewListSaga(action) {
	try {
		const result = yield call(reviewService.getReviewList, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getReviewListSuccess(result?.data?.reviews))
		} else {
			yield put(getReviewListFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(getReviewListFailed(error))
		yield put(
			setNotification({
				data: error,
				severity: "error",
			})
		)
	}
}

function* getAllReviewsListSaga(action) {
	try {
		const result = yield call(reviewService.getAllReviewList, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getAllReviewListSuccess(result?.data?.reviews))
		} else {
			yield put(getAllReviewListFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(getAllReviewListFailed(error))
		yield put(
			setNotification({
				data: error,
				severity: "error",
			})
		)
	}
}

function* getReviewBasedOnIdSaga(action) {
	try {
		const result = yield call(reviewService.getReviewBasedOnFileId, action.payload)
		if (result.status === 200 && result.data.success === true) {
			yield put(getReviewBasedOnFileIdSuccess(result?.data?.reviews))
		}
	} catch (error) {
		yield put(getReviewBasedOnFileIdFailed(error))
	}
}

function* getReviewSaga(action) {
	try {
		const result = yield call(reviewService.getReview, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getReviewRequestSuccess(result?.data?.review))

			//restrictIds
			/*const restrictIds = Object.keys(result?.data?.review?.file_ids)?.length ? Object.keys(result?.data?.review?.file_ids) : []
			yield put(setReviewRestrictIds(restrictIds))

			const Ids = result?.data?.review?.file_ids

			//if user is caseAdmin
			if (restrictIds?.length && action?.payload?.is_case_admin && !_.isEmpty(Ids)) {
				const assigneeMap = new Map()
				const reviewAssignee = {}
				for (const iterator in Ids) {
					//assigneeMap
					if (Ids[iterator]?.user_id) {
						assigneeMap.set(iterator, Ids[iterator]?.user_id)
					}

					//reviewAssignee
					if (!Object.hasOwn(reviewAssignee, Ids[iterator]?.user_id) && Ids[iterator]?.user_id) {
						reviewAssignee[Ids[iterator]?.user_id] = [iterator]
					} else if (Ids[iterator]?.user_id) {
						reviewAssignee[Ids[iterator]?.user_id] = [...reviewAssignee[Ids[iterator]?.user_id], iterator]
					}
				}

				yield put(setReviewAsignee(reviewAssignee))
				yield put(setReviewAssigneeMap(assigneeMap))
			}*/
		} else {
			yield put(getReviewRequestFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(getReviewRequestFailed(error))
		yield put(
			setNotification({
				data: error,
				severity: "error",
			})
		)
	}
}

function* updateReviewStatusSaga(action) {
	try {
		const result = yield call(reviewService.updateReviewStatus, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(updateReviewStatusSuccess(result?.data?.review))
			//update metadata in viewer screen
			yield put(updateDocumentModalReview(action.payload))
		} else {
			yield put(updateReviewStatusFailed(result))
		}
	} catch (error) {
		yield put(updateReviewStatusFailed(error))
	}
}

export function* adminReviewMapSaga(fileIds = []) {
	const currentReviewAssignee = yield select((state) => state.review.reviewAssignee)
	const currentAssigneeMap = yield select((state) => state.review.assigneeMap)

	let Ids = {}
	fileIds?.forEach((file) => {
		Ids[file.id] = {
			user_id: file?.review_assigned_user || null,
		}
	})

	const restrictIds = Object.keys(Ids)?.length ? Object.keys(Ids) : []
	if (restrictIds?.length && !_.isEmpty(Ids)) {
		const assigneeMap = new Map()
		const reviewAssignee = {}
		for (const iterator in Ids) {
			//assigneeMap
			if (Ids[iterator]?.user_id) {
				assigneeMap.set(iterator, Ids[iterator]?.user_id)
			}

			//reviewAssignee
			if (!Object.hasOwn(reviewAssignee, Ids[iterator]?.user_id) && Ids[iterator]?.user_id) {
				reviewAssignee[Ids[iterator]?.user_id] = [iterator]
			} else if (Ids[iterator]?.user_id) {
				reviewAssignee[Ids[iterator]?.user_id] = [...reviewAssignee[Ids[iterator]?.user_id], iterator]
			}
		}

		const updatedReviewAsignee = updateReviewAsignee(currentReviewAssignee, reviewAssignee)
		const updatedReviewAsigneeMap = updateReviewAsigneeMap(currentAssigneeMap, assigneeMap)
		yield put(setReviewAsignee(updatedReviewAsignee))
		yield put(setReviewAssigneeMap(updatedReviewAsigneeMap))
	}
}

function* reviewWatcher() {
	yield takeLatest(CREATE_REVIEW_REQUEST, createReviewSaga)
	yield takeLatest(GET_REVIEW_LIST_REQUEST, getReviewListSaga)
	yield takeLatest(GET_REVIEW_REQUEST, getReviewSaga)
	yield takeLatest(UPDATE_REVIEW_STATUS, updateReviewStatusSaga)
	yield takeLatest(GET_REVIEW_BASED_ON_ID, getReviewBasedOnIdSaga)
	yield takeLatest(GET_ALL_REVIEWS_LIST_REQUEST, getAllReviewsListSaga)
}

export default reviewWatcher
